module.exports = __webpack_public_path__ + "static/Dulcie-15848c60142e796906cc762faeefdabf.png";